import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarIcon, ClipboardCheckIcon, ShoppingCartIcon, LayoutTemplateIcon, AlertTriangleIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
const deliverables = [{
  icon: BookOpenIcon,
  title: 'Ebook PDF completo',
  description: '21 días paso a paso con explicaciones claras'
}, {
  icon: CalendarIcon,
  title: 'Planner imprimible',
  description: 'Para organizar tu semana sin estrés'
}, {
  icon: ClipboardCheckIcon,
  title: 'Tracker 21D',
  description: '2–4 minutos diarios para monitorear tu progreso'
}, {
  icon: ShoppingCartIcon,
  title: 'Lista de mercado base',
  description: 'Adaptada para Colombia + sustituciones'
}, {
  icon: LayoutTemplateIcon,
  title: 'Plantillas "Plato estable"',
  description: 'Para armar comidas sin pensar'
}, {
  icon: AlertTriangleIcon,
  title: 'Protocolo Rojo 24h',
  description: 'Qué hacer cuando estás en emergencia'
}];
export function EntregablesSection() {
  return <section className="w-full bg-[#FAF3E0] py-20 md:py-28 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div {...fadeInUp} className="text-center mb-16" data-id="element-3">
          <p className="text-[#C75B39] font-medium tracking-wide uppercase mb-4" data-id="element-4">
            Lo que recibes
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4332] mb-6" data-id="element-5">
            Todo lo que incluye
          </h2>
          <p className="text-[#1B4332]/70 text-lg max-w-2xl mx-auto" data-id="element-6">
            Cuando compras, recibes acceso inmediato a:
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6" data-id="element-7">
          {deliverables.map((item, index) => <motion.div key={item.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1 * index
        }} className="flex items-start gap-4 bg-white rounded-2xl p-6 shadow-md" data-id="element-8">
              <div className="w-12 h-12 rounded-xl bg-[#A7C4A0]/30 flex items-center justify-center flex-shrink-0" data-id="element-9">
                <item.icon className="w-6 h-6 text-[#1B4332]" data-id="element-10" />
              </div>
              <div data-id="element-11">
                <h3 className="font-bold text-[#1B4332] text-lg mb-1" data-id="element-12">
                  {item.title}
                </h3>
                <p className="text-[#1B4332]/60 text-sm" data-id="element-13">{item.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}